import { render, staticRenderFns } from "./FinancialRatiosTable.vue?vue&type=template&id=088c9105&scoped=true&"
import script from "./FinancialRatiosTable.vue?vue&type=script&lang=js&"
export * from "./FinancialRatiosTable.vue?vue&type=script&lang=js&"
import style0 from "./FinancialRatiosTable.vue?vue&type=style&index=0&id=088c9105&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088c9105",
  null
  
)

export default component.exports